import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "ott-platform-slider-bottom" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "arrow-btn" }

import { ref } from "vue";
import Lightgallery from "lightgallery/vue";
import lgVideo from "lightgallery/plugins/video";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-video.css";


export default /*@__PURE__*/_defineComponent({
  __name: 'WatchTeaserTrailer',
  setup(__props) {

const plugins = ref([lgVideo]);

const videos = ref([
  {
    url: "https://www.youtube.com/watch?v=e1GrRouA5D8",
    thumbnail: require("@/assets/images/ott-platform/img1.jpg"),
  },
  {
    url: "https://www.youtube.com/watch?v=e1GrRouA5D8",
    thumbnail: require("@/assets/images/ott-platform/img2.jpg"),
  },
]);

const onInit = () => console.log("lightGallery initialized");

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title" }, [
      _createElementVNode("h5", null, "WATCH TEASER & TRAILER")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Lightgallery), {
        settings: { speed: 500, plugins: plugins.value },
        onOnInit: onInit
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(videos.value, (video, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: index,
              href: video.url,
              class: "video-btn"
            }, [
              _createElementVNode("img", {
                src: video.thumbnail,
                alt: 'Video ' + (index + 1)
              }, null, 8, _hoisted_4),
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-play-fill" }, null, -1))
            ], 8, _hoisted_3))
          }), 128))
        ]),
        _: 1
      }, 8, ["settings"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_RouterLink, { to: "/channel-list" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})